import React from "react";
import "../../../../styles/Pages/Operational/Academic/Attendance/Attendance.style.css";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import PageHeaderCustom from "../../../../components/PagesComponents/Operational/Academic/Attendance/PageHeaderCustom.component";
import { ReactComponent as FilterIcon } from "../../../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/Icons/Sidebar/ArrowDown.svg";
import IndivisualMemberCard from "../../../../components/PagesComponents/Organizational/Management/Members/IndivisualMemberCard.component";
import profileImg from "../../../../assets/Images/TestImg/profileImage.png";
import TableCard from "../../../../components/Universal/TableCard.component";
import AttendanceShortCard from "../../../../components/PagesComponents/Operational/Academic/Attendance/AttendanceShortCard.component";
import { Helmet } from "react-helmet";
const Body = ({
  classRepresentativeData,
  managementData,
  staffsProfileData,
  teachersProfileData,
  studentsData,
  setGenderWaysFilter,
  genderWaysFilter,
}) => {
  return (
    <section className={"attendancePage"}>
      <Helmet>
        <title>Attendence</title>
      </Helmet>
      <PageHeader
        renderCustomElement={
          <PageHeaderCustom
            setGenderWaysFilter={setGenderWaysFilter}
            genderWaysFilter={genderWaysFilter}
          />
        }
      />

      <div className="classRepresentetiveSection">
        <button className="classRepresentativeFilterBtn">
          <div className="flex-col align-center justify-center g-05">
            <span>
              Class <br />
              representative
            </span>
            <div className="flex-row align-center justify-center g-05">
              <FilterIcon className="classRepresentativeFilterBtnIcon" />
              <span>Filter</span>
            </div>
          </div>
        </button>
        <div className="scrollableRepresentetiveSec flex-1 h-full">
          <div className="w-fit flex-row align-center justify-center g-05 h-full">
            {classRepresentativeData &&
              classRepresentativeData.map((data) => {
                return (
                  <div className="classRepresentativeCard" key={data._id}>
                    <p>{data.name}</p>
                    <p>
                      C-{data.class}, S-{data.section}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="scrollIndicatorForClassRepresentative">
          <ArrowIcon
            style={{
              transform: "rotate(-90deg)",
              stroke: "white",
              width: "1.2rem",
              height: "1.2rem",
            }}
          />
        </div>
      </div>

      <div className="attendenceCardsMain">
        <div className="attendenceCardsParentLeft ">
          <div className="managementCard">
            <TableCard
              title="Management"
              tableHead={["Name and id", "Designation", "Appeared"]}
            >
              {managementData &&
                managementData.map((user) => (
                  <IndivisualMemberCard
                    key={user._id}
                    image={profileImg}
                    name={user.name}
                    profileId={user.profileId}
                    designation={user.designation}
                    percentage={user.percentage}
                  />
                ))}
            </TableCard>
          </div>

          <div className="w-full flex-1 overflow-hide flex-row g-1 align-start justify-start">
            <div className="staffsAttendance">
              <TableCard
                title="Staffs"
                tableHead={["Name and id", "Working field"]}
              >
                {staffsProfileData &&
                  staffsProfileData.map((user) => (
                    <AttendanceShortCard
                      key={user._id}
                      image={profileImg}
                      name={user.name}
                      profileId={user._id}
                      designation={user.working_field}
                    />
                  ))}
              </TableCard>
            </div>
            <div className="teachersAttendance">
              <TableCard
                title="Teachers"
                tableHead={["Name and id", "Subject"]}
              >
                {teachersProfileData &&
                  teachersProfileData.map((user) => (
                    <AttendanceShortCard
                      key={user._id}
                      image={profileImg}
                      name={user.name}
                      profileId={user._id}
                      designation={user.subject}
                    />
                  ))}
              </TableCard>
            </div>
          </div>
        </div>
        <div className="attendenceCardsParentRight">
          <div className="studentsAttendance">
            <TableCard
              title="All Students"
              tableHead={["Name and id", "Class", "Appeared"]}
            >
              {studentsData &&
                studentsData.map((user) => (
                  <IndivisualMemberCard
                    key={user._id}
                    image={profileImg}
                    name={user.name}
                    profileId={user._id}
                    classSec={`C-${user.class},S-${user.section}`}
                    percentage={user.appeared}
                    designation={""}
                  />
                ))}
            </TableCard>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
